<div class="px-3 py-2 bg-neutral-900/[.30] rounded-lg text-xs">
  <div
    [ngClass]="{ 'border-b-[0.5px] border-b-neutral-700 pb-1.5 mb-1.5': showMore }"
    class="flex justify-between leading-[22px]"
  >
    <div>
      @if (added().length) {
        <span class="text-green-300 font-bold">{{ added().length }} added</span>
      }
      @if (added().length && (updated().length || removed().length)) {
        <span>; </span>
      }
      @if (updated().length) {
        <span class="text-yellow-300 font-bold">{{ updated().length }} updated</span>
      }
      @if (updated().length && removed().length) {
        <span>; </span>
      }
      @if (removed().length) {
        <span class="text-red-300 font-bold">{{ removed().length }} removed</span>
      }
    </div>

    <button
      (click)="showMore = !showMore"
      class="font-semibold cursor-pointer select-none"
    >
      {{ showMore ? 'Less' : 'More' }}
    </button>
  </div>

  @if (showMore) {
    <div class="flex flex-col gap-0.5">
      @if (added().length) {
        <div class="text-green-300 font-bold leading-[22px]">
          Dependencies Added ({{ added().length }}):
        </div>
        @for (dep of added(); track dep.name) {
          <div class="flex gap-1 leading-[18px] items-center even:bg-white/[.05]">
            <span>{{ dep.name }}</span>
            <span class="text-neutral-400">{{ dep.version }}</span>
          </div>
        }
      }

      @if (updated().length) {
        <div class="text-yellow-300 font-bold leading-[22px] mt-1">
          Dependencies Updated ({{ updated().length }}):
        </div>
        @for (dep of updated(); track dep.name) {
          <div class="flex gap-1 leading-[18px] items-center even:bg-white/[.05]">
            <span>{{ dep.name }}</span>
            <span class="text-neutral-400">{{ dep.oldVersion }} &rarr; {{ dep.newVersion }}</span>
          </div>
        }
      }

      @if (removed().length) {
        <div class="text-red-300 font-bold leading-[22px] mt-1">
          Dependencies Removed ({{ removed().length }}):
        </div>
        @for (dep of removed(); track dep.name) {
          <div class="flex gap-1 leading-[18px] items-center even:bg-white/[.05]">
            <span>{{ dep.name }}</span>
            <span class="text-neutral-400">{{ dep.version }}</span>
          </div>
        }
      }
    </div>
  }
</div>
